import { AdvisorsLayout, DirectorySection } from '@src/components/sco/Advisors'
import { advisorsDirectorySeo } from '@src/components/sco/Advisors/utils/advisorsSeo'
import { usePageSEO } from '@src/hooks/usePageSEO'
import { useRouter } from 'next/router'

export { getServerSideProps } from '@src/lib/server-side-rendering'

/**
 * Category page (in the sitemap). Guest-reachable and server-rendered (L3).
 * The path segment still works; filters rewrite to `?category=` on change.
 */
export default function Page() {
  const router = useRouter()
  const categoryKey = typeof router.query.categoryKey === 'string' ? router.query.categoryKey : null
  usePageSEO(advisorsDirectorySeo(categoryKey))

  return (
    <AdvisorsLayout>
      <DirectorySection />
    </AdvisorsLayout>
  )
}
